/**
 * File: useReadyToSendController.ts
 * Path: apps/admin/src/shared/hooks/useReadyToSendController.ts
 * Description: The Ready to send box on Money and Today: the drafts waiting
 * for Liam, read from the books' invoice list, and sending one with one tap
 * (it gets its number, goes in the books and is emailed to the client with
 * its PDF; if the email can't go, it stays issued and says why).
 */

import { useMemo } from "react";
import { ADMIN_PATHS } from "@idk/config";
import { readyToSend } from "../utils/readyToSendUtils";
import { useInvoiceSendingMutations } from "./useInvoiceSendingMutations";
import { useInvoiceLedger } from "./useInvoiceLedgerQueries";

export const useReadyToSendController = () => {
  const { ledger, saved } = useInvoiceLedger();
  const { issueAndEmail, pending } = useInvoiceSendingMutations();
  const rows = useMemo(() => (ledger && ledger !== "unavailable" ? readyToSend(ledger, saved) : []), [ledger, saved]);
  return {
    rows,
    pending,
    hrefOf: (invoiceId: string) => ADMIN_PATHS.invoice(invoiceId),
    send: issueAndEmail,
  };
};
